<template>
    <div class="card-header">
        <div class="card-title">
            <div>
                <i
                    v-if="icon"
                    class="mr-2"
                    :class="icon"
                ></i>
                {{ title }}
            </div>
            <span
                class="required-fields"
                v-if="flagRequired"
            >
                <span class="required">*</span>
                Campos obrigatórios
            </span>
        </div>
    </div>
</template>
<script>

export default {
    props: {
        title: {
            type: String,
            required: true
        },
        icon: {
            type: String,
            required: false
        },
        flagRequired: {
            type: Boolean,
            default: true
        }
    }
}

</script>

<style scoped>
.card-title {
    color: white;
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.required-fields {
    font-size: 12px;
    opacity: 0.9;
}

@media (max-width: 768px) {
    .card-title {
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
    }

    .required-fields {
        align-self: flex-end;
    }

    .alert-content i {
        margin-top: 0;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Base/CardHeader.vue